import moment from "moment";

export const getCheckInQuestions = (coach, athlete) => {
  //if the athlete has a template assigned, I looked for it on the coach questionnaire templates and return it,
  if (athlete.questionnaire?.templateId) {
    const assignedTemplate = coach?.questionnaireTemplates?.templates?.find(
      (template) => template._id === athlete.questionnaire.templateId
    );
    if (assignedTemplate) return assignedTemplate.questions;
  }
  //if there isn't template assigned, I check if the athlete has a list of questions and return it
  if (athlete.questionnaire?.questions) {
    return athlete.questionnaire?.questions;
  }
  // In any other case, I return the default template assigned by the coach
  if (coach?.questionnaireTemplates?.defaultTemplate) {
    const assignedTemplate = coach?.questionnaireTemplates?.templates?.find(
      (template) =>
        template._id === coach.questionnaireTemplates.defaultTemplate
    );
    if (assignedTemplate) return assignedTemplate.questions;
  }
  //If the coach hasnt selected a default template yet, an empty array is returned
  return [];
};

export const getCheckInSchedule = (athlete) => {
  const schedule = athlete.questionnaire?.schedule;

  return schedule || null;
};

// Days to limit searches depending on the frequency selected for the check in
export const frequencyLimit = {
  daily: 7,
  weekly: 7,
  biweekly: 14,
  monthly: 30,
};

export const displayDateRange = (start, end) => {
  return `${moment(start).format("MMM D, YYYY")} - ${moment(end).format(
    "MMM D, YYYY"
  )}`;
};
